import { render } from "./Admission.vue?vue&type=template&id=224c1ee6"
import script from "./Admission.vue?vue&type=script&lang=js"
export * from "./Admission.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__